import {
  DomainGraphInterface,
  DomainGraphType,
  MaybeCoreObject,
  ObjectType,
} from 'app-core/framework/CoreObjectConstants';
import {
  getObjectType,
  isCoreObject,
  isCoreObjectWithInterface,
} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';

/**
 * TODO: Don't add to this list. When adding to capabilityEnabledByConfig, remove from this list.
 * @package
 */
export const TEMPORARY_COLLABORATABLE_ITEM_TYPE_IGNORE_LIST: Set<ObjectType> = new Set([
  DomainGraphType.AA_SEQUENCE_SCHEMA,
  DomainGraphType.ANTIBODY_SCHEMA,
  DomainGraphType.DNA_OLIGO_SCHEMA,
  DomainGraphType.DNA_SEQUENCE_SCHEMA,
  DomainGraphType.ENTITY_SCHEMA,
  DomainGraphType.EQUIPMENT_SCHEMA,
  DomainGraphType.FEATURE_LIBRARY,
  DomainGraphType.MIXTURE_SCHEMA,
  DomainGraphType.MOLECULE_SCHEMA,
  DomainGraphType.OLIGO_CONJUGATE_SCHEMA,
  DomainGraphType.OLIGO_DUPLEX_SCHEMA,
  DomainGraphType.PROJECT,
  DomainGraphType.REGISTRY,
  DomainGraphType.RESULT_SCHEMA,
  DomainGraphType.RNA_OLIGO_SCHEMA,
  DomainGraphType.RNA_SEQUENCE_SCHEMA,
  DomainGraphType.RUN_SCHEMA,
  DomainGraphType.STAGE_ENTRY,
  DomainGraphType.TEMPLATE_COLLECTION,
  DomainGraphType.WORKLIST,
]);

/** @package */
export function capabilityEnabledByConfig(coreObjectType: ObjectType): boolean {
  const coreObjectTypeEnabled = new Map<ObjectType, boolean>([
    [DomainGraphType.FOLDER, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_FOLDER_PERMISSIONS],
    [DomainGraphType.ENTRY, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTRY_PERMISSIONS],
    [DomainGraphType.MOLECULE, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.MIXTURE, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.AA_SEQUENCE, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.DNA_OLIGO, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.DNA_SEQUENCE, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.RNA_OLIGO, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.RNA_SEQUENCE, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.CUSTOM_ENTITY, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.OLIGO_CONJUGATE, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.OLIGO_DUPLEX, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
    [DomainGraphType.ANTIBODY, BenchlingConfig.PERMISSIONS_ENABLE_GRANULAR_ENTITY_PERMISSIONS],
  ]);
  assert(
    coreObjectTypeEnabled.has(coreObjectType),
    `Core object type ${coreObjectType} must be mapped in isCollaboratable.`
  );
  return Boolean(coreObjectTypeEnabled.get(coreObjectType));
}

export default function isCollaboratable(item: MaybeCoreObject): boolean {
  if (!isCoreObject(item)) {
    return false;
  } else {
    const objectType = getObjectType(item);
    return (
      isCoreObjectWithInterface(item, DomainGraphInterface.COLLABORATABLE) &&
      !TEMPORARY_COLLABORATABLE_ITEM_TYPE_IGNORE_LIST.has(objectType) &&
      capabilityEnabledByConfig(objectType)
    );
  }
}

export function isCollaboratableId(id: string): boolean {
  return isCollaboratable({id});
}
